import {
  createFrontendModule,
  createTranslationMessages,
} from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { techdocsTranslationRef } from '@backstage/plugin-techdocs/alpha';

export { techdocsAvailabilityModule } from './techdocs-availability';

// A Docs tab does not guarantee a published site. Keep the underlying error
// visible and explain our external builder instead of suggesting local builds.
const techdocsMessages = TranslationBlueprint.make({
  name: 'techdocs-messages',
  params: {
    resource: createTranslationMessages({
      ref: techdocsTranslationRef,
      messages: {
        'notFound.title': 'Documentation is not available yet',
        'notFound.builderNote':
          'If this repository has no documentation yet, add a README.md or docs/index.md on its default branch. The next successful hourly build will publish it here. If documentation already exists, check the page URL and the builder logs using the generation guide above.',
        'stateIndicator.contentStaleError.message':
          'Documentation could not be refreshed. See the error details below and the generation guide above for help checking the builder logs.',
      },
    }),
  },
});

export const techdocsMessagesModule = createFrontendModule({
  pluginId: 'app',
  extensions: [techdocsMessages],
});
